module.exports = __webpack_public_path__ + "img/icon_cjlb.efa643a3.png";